import { Router } from '@angular/router';

/**
 * True when the current page is the header eye-icon ("View") menu.
 *
 * That menu is the /suggestions page opened with master=HEADER_WIDGETS, and the
 * header (LangdingPageNavBarComponent) is the only place in the app that sets that
 * value. /suggestions is also the target of every widget "View more" link, but those
 * pass their own page as the master, so they are correctly excluded.
 *
 * Used to scope behaviour changes to the eye-icon menu alone. The job card, the
 * candidate card and the candidate detail row render on dozens of other screens, and
 * several of the ten eye-icon widgets also appear in the right-hand widget column, so
 * a flag set on the components themselves would leak. Checking the page does not.
 */
export function isEyeIconMenu(router: Router): boolean {
  const tree = router.parseUrl(router.url);
  const firstSegment = tree.root.children['primary']?.segments?.[0]?.path;
  return firstSegment === 'suggestions' && tree.queryParams['master'] === 'HEADER_WIDGETS';
}
